/**
 * @generated SignedSource<<43f3b5319d869f959bca4e5dd538dd09>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type PackageBillingType = "ONE_TIME" | "SUBSCRIPTION";
import { FragmentRefs } from "relay-runtime";
export type useShouldShowCancelButton_memberPackage$data = {
  readonly cancelledOn: string | null | undefined;
  readonly endsOn: string | null | undefined;
  readonly package: {
    readonly billingType: PackageBillingType;
  };
  readonly " $fragmentType": "useShouldShowCancelButton_memberPackage";
};
export type useShouldShowCancelButton_memberPackage$key = {
  readonly " $data"?: useShouldShowCancelButton_memberPackage$data;
  readonly " $fragmentSpreads": FragmentRefs<"useShouldShowCancelButton_memberPackage">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useShouldShowCancelButton_memberPackage",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "cancelledOn",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endsOn",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "package",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "billingType",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "MemberPackage",
  "abstractKey": null
};

(node as any).hash = "f9f630f9ed47f30a5dbf72ae4f513ed9";

export default node;
